module.exports = __webpack_public_path__ + "static/media/ic_tester.1a27c587.svg";